import { isSystemEntity } from '@backstage/catalog-model';
import {
  DevHubBox,
  DevHubDynamicIcon,
  DevHubIconButton,
} from '@devxdiscover/devhub-ui';
import {
  default as React,
  Fragment,
  useContext,
  useEffect,
  useState,
} from 'react';
import { registerComponentInterceptor } from '../componentInterceptor';
import { SystemContext } from '../../contexts/SystemContext';
// @ts-ignore
import StringCase from 'case';

/**
 * Provides a custom layout for the EntityLayoutTitle on the Entity page.
 * @param props Props for the jsx element
 */
export const CustomEntityLayoutTitle = (props: any) => {
  const { app, loading } = useContext(SystemContext);
  const [appName, setAppName] = useState<string | undefined>(undefined);
  const { entity } = props.props;
  const [isStarred, setIsStarred] = useState<boolean>(
    !!localStorage
      .getItem('starredApplications')
      ?.includes(
        String(entity?.metadata?.annotations?.['comcast.net/itrc-id']),
      ),
  );

  useEffect(() => {
    setAppName(app?.name);
  }, [app, loading]);

  const toggleStar = () => {
    const entityRef = Number(
      entity?.metadata?.annotations?.['comcast.net/itrc-id'],
    );
    const currentArray = localStorage.getItem('starredApplications');
    const newArray = currentArray ? JSON.parse(currentArray) : [];

    const index = newArray.indexOf(entityRef);
    if (index !== -1) {
      // Remove the ID if it already exists
      newArray.splice(index, 1);
    } else {
      // Add the ID if it doesn't exist
      newArray.push(entityRef);
    }
    localStorage.setItem('starredApplications', JSON.stringify(newArray));
    setIsStarred(!isStarred);
  };

  return (
    // This layout was taken from the original EntityLayoutTitle
    <>
      <DevHubBox
        display="inline-flex"
        alignItems="center"
        height="1em"
        maxWidth="100%"
        paddingBottom="0rem"
      >
        <DevHubBox
          component="span"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          {entity && isSystemEntity(entity) && (
            <Fragment>
              {appName ??
                entity?.metadata?.title ??
                entity?.metadata?.name ??
                ''}
            </Fragment>
          )}

          {!(entity && isSystemEntity(entity)) && (
            <Fragment>
              {entity?.metadata?.title ?? entity?.metadata?.name ?? ''}
            </Fragment>
          )}
        </DevHubBox>
        {/* Show the little favorite thingy so users can show their adoration for individual entities */}
        {entity && isSystemEntity(entity) && (
          <DevHubIconButton onClick={toggleStar}>
            <DevHubDynamicIcon
              iconName="StarSharp"
              fontSize="large"
              color={isStarred ? 'gold' : 'medGray'}
            />
          </DevHubIconButton>
        )}
      </DevHubBox>
      <DevHubBox style={{ lineHeight: '1.5rem', opacity: '0.8' }}>
        <span className="MuiTypography-root MuiTypography-subtitle2 BackstageHeader-subtitle">
          {/* If this is a system entity, then display the namespace */}
          {entity && isSystemEntity(entity) && (
            <DevHubBox component="span">
              {StringCase.capital((entity?.metadata?.type as string) ?? '')}
            </DevHubBox>
          )}

          {entity && !isSystemEntity(entity) && (
            <DevHubBox component="span">
              {StringCase.capital((entity?.spec?.type as string) ?? '')}
            </DevHubBox>
          )}
          {/* Display the title or name... or nothing. muhahahaha */}
        </span>
      </DevHubBox>
    </>
  );
};

/**
 * Register this component as an override for the default EntityLayoutTitle.
 */
registerComponentInterceptor({
  canIntercept(type: React.ElementType, props: any, _key: React.Key) {
    return (
      (type as any)?.name === 'EntityLayoutTitle' &&
      !!(props?.entity && props.entity?.kind === 'System')
    );
  },
  performIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return {
      element: <CustomEntityLayoutTitle props={props} />,
    };
  },
});
